import { COLORS } from '@btime/constants'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useChecklistFormActions, useSelectedQuestion } from '../../../../_form/ChecklistFormHandler'
import FormItem from '../../../../../../../components/form/FormItem'
import Icon from '../../../../../../../packages/kiti/components/shapes/Icon'
import Link from '../../../../../../../packages/kiti/components/actions/Link'
import ExpandableQuestionModal from '../modal/ExpandableQuestionModal'
import Textarea from '../../../../../../../components/form/Textarea'
import { SmallText } from '../../../../../../../components/presentation/Text'
import Separator from '../../../../../../../packages/kiti/components/helpers/Separator'

const GeneralSection = () => {
  const { t } = useTranslation('editChecklist')
  const { handleSelectedQuestionChange } = useChecklistFormActions()
  const selectedQuestion = useSelectedQuestion()
  const [openExplandableModal, setOpenExpandableModal] = useState(false)

  const { randomIdAfterUndo } = useChecklistFormActions()

  return (
    <>
      {selectedQuestion.questionType?.name === 'calc' && (
        <>
          <SmallText color={COLORS.dark5}>{t('calcWarning')}</SmallText>
          <Separator weight={2} />
        </>
      )}

      <FormItem
        key={randomIdAfterUndo}
        label={t('question')}
        field="name"
        form={selectedQuestion}
        right={
          <Link onClick={() => setOpenExpandableModal(true)}>
            <Icon name="BsArrowsAngleExpand" color={COLORS.dark3} size="0.6rem" />
          </Link>
        }
      >
        <Textarea
          key={selectedQuestion.reference}
          disableRemount={true}
          limit={800}
          rows={1}
          value={selectedQuestion.name}
          onBlur={() => null}
          onStopTyping={handleSelectedQuestionChange('name')}
        />
      </FormItem>
      <ExpandableQuestionModal
        open={openExplandableModal}
        onClose={() => setOpenExpandableModal(false)}
        field="name"
        label={t('question')}
      />
    </>
  )
}

export default GeneralSection
